import React from 'react';
const BreadcrumbContext = React.createContext({});
export default BreadcrumbContext;
